import React from "react";
import "../../css/Footer.css";

function Footer() {
  return (
    <footer className="text-center py-2 bg-light mt-auto fixed-bottom">
      <div className="container">
        {/* <p style={{marginBottom: '0.1rem'}}>
          <a href='/terms' className='text-muted mx-2'>
            <span style={{fontSize:"12px"}}>Terms and Conditions</span>
          </a>{' '}
          |
          <a href='/privacy' className='text-muted mx-2'>
          <span style={{fontSize:"12px"}}>Privacy Policy</span>
          </a>{' '}
          |
          <a href='/contact' className='text-muted mx-2'>
          <span style={{fontSize:"12px"}}>Contact</span>
          </a>
        </p> */}
        <p
          className="text-muted"
          style={{
            lineHeight: "normal",
            fontSize: "14px",
            height: "7vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "4px",
          }}
        >
          Powered by{" "}
          <a href="https://appantech.com" className="text-primary">
            AppanTech.com
          </a>
        </p>
      </div>
    </footer>
  );
}

export default Footer;
